(function () {
	'use strict';
	var controllerId = 'userAdd';

	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', 'societa', 'societaId', userAdd]);

	function userAdd($scope, $uibModalInstance, datacontext, sectionMenu, societa, societaId) {
	    $scope.user = {};
	    $scope.user.Attivato = true;
		$scope.societa = societa;

		//Parametro classeId utilizzato per impostare e bloccare selezione Classe
		//Utilizzato in caso di creazione unovo studente da view /app/classe/classeDetail.html
		if (societaId) {
			$scope.societaId = societaId;
			$scope.studente.SocietaId = societaId;
		}
        
		$scope.ok = function (isValid) {
			if (isValid) {
				var result = addItem($scope.user)
				$uibModalInstance.close(result);
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};		

		function addItem(item) {
			item.DtAttivazione = new Date();
			return datacontext.user_add(item).then(function (data) {			    
			    if (!data || data.Id == null || data.Id == 0) return null;
                
			    return data;
			});
		}
	}
})();